/*
 * @Author: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @Date: 2026-08-27 19:35:50
 * @LastEditors: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @LastEditTime: 2026-08-27 19:51:25
 * @FilePath: \watherfocast2\src\utils\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 认证信息与站点列表的本地存储封装
const TOKEN_KEY = 'token'
const USER_KEY = 'user'
const STATIONS_KEY = 'stations'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TOKEN_KEY)
  }
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  } catch (e) {
    return null
  }
}

export function setUser(user) {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  } else {
    localStorage.removeItem(USER_KEY)
  }
}

// 归一化站点列表：兼容后端 stationCode/stationKey/stationName 与 find/hydro_station_code/station_name 两种字段
export function normalizeStations(list) {
  if (!Array.isArray(list)) return []
  return list.map((s) => {
    if (!s || typeof s !== 'object') {
      const v = String(s)
      return { find: v, station_code: v, station_name: v }
    }
    const find = (s.stationCode !== undefined && s.stationCode !== null)
      ? String(s.stationCode)
      : ((s.find !== undefined && s.find !== null) ? String(s.find) : '')
    const station_code = (s.stationKey !== undefined && s.stationKey !== null)
      ? String(s.stationKey)
      : (s.hydro_station_code || s.station_code || find)
    const station_name = s.stationName || s.station_name || s.name || ''
    return Object.assign({}, s, { find, station_code, station_name })
  })
}

export function getStations() {
  try {
    return normalizeStations(JSON.parse(localStorage.getItem(STATIONS_KEY) || '[]'))
  } catch (e) {
    return []
  }
}

export function setStations(list) {
  const normalized = normalizeStations(list)
  if (normalized.length > 0) {
    localStorage.setItem(STATIONS_KEY, JSON.stringify(normalized))
  } else {
    localStorage.removeItem(STATIONS_KEY)
  }
  return normalized
}

// 是否管理员：以登录返回的 is_admin 字段为准，兼容旧的 find === '10000' 约定
export function isAdmin() {
  const user = getUser()
  if (user) {
    if (user.isAdmin === true || user.isAdmin === 1 || user.is_admin === true || user.is_admin === 1) return true
    if (String(user.find) === '10000') return true
  }
  return localStorage.getItem('stationId') === '10000'
}

// 获取默认选中的水电站 find：优先站点列表第一个，其次登录返回的 find
export function getDefaultFind() {
  const stations = getStations()
  if (stations && stations.length > 0) {
    const first = stations[0]
    if (first && first.find) return String(first.find)
    if (first && first.stationCode) return String(first.stationCode)
  }
  const user = getUser()
  if (user && user.find && String(user.find) !== '10000') return String(user.find)
  return localStorage.getItem('stationId') || ''
}

// 清空全部登录态
export function clearAuth() {
  const keys = ['token', 'user', 'stations', 'isLoggedIn', 'username', 'userId', 'stationId', 'hyStation']
  keys.forEach(k => localStorage.removeItem(k))
}

// 主动退出登录的静默标志：置为 true 后，后续接口 401/403 不再弹提示框，避免多个提示叠加
let silentOnAuthFail = false
export function setSilentOnAuthFail(value) {
  silentOnAuthFail = !!value
}
export function isSilentOnAuthFail() {
  return silentOnAuthFail
}